import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    accessButton: {
      padding: 0,
      '& .MuiSvgIcon-root': {
        fontSize: 15,
        color: palette.blue,
      },
    },
    modalTitle: {
      gap: '8px',
      '& .MuiTypography-root': {
        fontSize: 14,
      },
    },
    flavorName: {
      fontWeight: 'bold',
    },
  });
